export const FINITE_STATE_OBSERVABLE_PRIVATE = Symbol('finite-state-observable-private');
//# sourceMappingURL=privates.js.map